import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

// export the component theme
export const containerTheme = {}
